// 用户
import { User, user_modify, user_query, user_upsert, UserModifyCond } from '../db/t_user';
import Context from './context';
import time from '../time';
import log from '../log';
import { login_device_upsert, LoginDevice, queryLoginDevicesLocal } from '../db/t_user_devices';
import { loginDevices } from '../../src/net/service';
import { config_get } from '../db/t_config';

export default class UserController {
    // 获取用户信息，如果用户不存在，则返回一个临时占位数据
    // 然后调用接口去后台查询，补齐数据后通过事件通知外部更新
    // 如果本地有数据，也检查一下数据的最后更新时间，如果时间超过了5天，先返回，也强行到后台查一把
    public static async GetMuti(
        ctx: Context,
        uids: number[],
        sync: boolean = false, // 是否同步查
    ): Promise<{ error: any; users?: User[] }> {
        uids = (uids || []).filter(uid => uid != null && uid !== 0 && Number.isFinite(uid) && Number.isInteger(uid));
        if (uids.length === 0) return { error: null };
        const r = await user_query(ctx.db, uids);
        if (r.error) {
            // db错误是大问题，重试也没办法，后台监控到日志想办法修复
            return { error: r.error };
        }

        const users = r.users || [];
        const n = users.length;

        // 如果本地没有用户数据，或数据库的记录是2天前的，强制性再查一把，异步通知
        const exp = time.toUnixMillSecond(time.add(time.now(), -2 * time.DAY));
        for (let i = 0; i < n; i++) {
            if (users[i].lutime > exp) {
                // 还没过期
                const idx = uids.indexOf(users[i].uid);
                if (idx >= 0 && idx < uids.length) {
                    uids.splice(idx, 1);
                }
            }
        }

        if (uids && uids.length > 0) {
            if (sync) {
                const r2 = await UserController.GetRemote(ctx, uids);
                if (r2.users && r2.users.length > 0) {
                    users.push(...r2.users);
                }
            } else {
                UserController.GetRemote(ctx, uids).then(() => {
                });
            }
        }

        return { error: null, users: users };
    }

    // 从远端直接查
    public static async GetRemote(
        ctx: Context,
        uids: number[],
    ): Promise<{ error: any; users?: User[] }> {
        const r2 = await ctx.conn.Call('/v1/sdk/user/detail', { uids: uids });
        if (!(r2 && r2.code === 0)) {
            log.warn(
                '查询用户信息失败! uid:',
                uids,
                'rsp:',
                JSON.stringify(r2),
            );
            return { error: r2 };
        }
        if (!(r2.data && r2.data.users && r2.data.users.length > 0)) {
            log.info(
                '查询用户信息为空! uids:',
                uids,
                'rsp:',
                JSON.stringify(r2),
            );
            return { error: null };
        }
        const rst = r2.data.users as User[];
        await UserController.UpdateLocalUserInfo(ctx, rst);
        return { error: null, users: rst };
    }

    public static async UpdateLocalUserInfo(ctx: Context, users: User[]) {
        const n = users.length;
        for (let i = 0; i < n; i++) {
            const r = await user_upsert(ctx.db, users[i]);
            if (!r.error) {
                ctx.mq.emit_stash("userinfo", {
                    userinfo: users[i],
                });
            }
        }
    }

    // 取一个用户的包装，方便接口调用
    public static async Get(
        ctx: Context,
        uid: number,
        sync: boolean = false, // 同步返回，当本地没有数据时去远端查一把
    ): Promise<{ error: any; user?: User }> {
        const r = await UserController.GetMuti(ctx, [uid], sync);
        if (r.error) {
            return { error: r.error };
        }
        if (r.users && r.users.length > 0) {
            return { error: null, user: r.users[0] };
        }
        return { error: null };
    }


    // 取一个用户的包装，方便接口调用   
    public static async UserModify(ctx: Context, cond: UserModifyCond,) {
        return await user_modify(ctx.db, cond);
    }

    public static async queryLoginDevices(ctx: Context): Promise<{ error: any; devices?: LoginDevice[] }> {
        return await queryLoginDevicesLocal(ctx.db, ctx.uid);
    }

    public static async queryFriendApplyNum(ctx: Context): Promise<{ error: any; friendApplyNum?: number }> {
        const r2 = await config_get(ctx.db, "friend_apply");
        if (r2.error) {
            return { error: r2.error };
        }
        if (r2.data && r2.data.val) {
            const num = parseInt(r2.data.val);
            if (!isNaN(num)) {
                return { error: null, friendApplyNum: num };
            }
        }
        return { error: null, friendApplyNum: 0 };
    }


    public static async updateLoginDevices(ctx: Context): Promise<{ error: any, devices?: LoginDevice[] }> {
        const res = await loginDevices()

        console.log("fetch login devices: ", JSON.stringify(res));

        if (res.err) {
            return { error: res.err };
        }

        if (res.code !== 0 && !res.data) {
            log.warn("获取登录设备列表失败", res.msg);
            return { error: res.msg ?? "获取登录设备列表失败" };
        }

        const d = res.data as LoginDevice[];
        if (!d || d.length === 0) {
            log.info("登录设备列表为空");
            return { error: res.msg ?? "获取登录设备列表失败" };
        }

        await login_device_upsert(ctx.db, ctx.uid, d);

        // 更新到state
        ctx.mq.emit_stash("user_devices", {
            user_devices: {
                devices: d,
                uid: ctx.uid,
            }
        });

        return { error: null, devices: d };
    }

}
